import BambooHRBlock from './bamboo-hr-block';

export default BambooHRBlock;
